import { render, staticRenderFns } from "./ActionBar.vue?vue&type=template&id=04610e8e&"
import script from "./ActionBar.vue?vue&type=script&lang=js&"
export * from "./ActionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports